import React, { useState } from "react";
import Spacing from "../Spacing";
import SectionHeadingStyle3 from "../SectionHeading/SectionHeadingStyle3";
import PostStyle5 from "../Post/PostStyle5";
import { Icon } from "@iconify/react";
import { pageTitle } from "../../helpers/PageTitle";
import { blogData } from "../../data/blogs";

export default function BlogListPage() {
  const [itemShow, setItemShow] = useState(5);
  pageTitle("Blog List");
  return (
    <>
      <Spacing lg="70" md="70" />
      <Spacing lg="140" md="80" />
      <div className="col-lg-5" style={{ marginLeft: "161px", marginTop: "50px" }}>
          <a href="/" className="cs_down_btn cs_center cs_primary_color">
            <svg
              style={{ transform: 'rotate(90deg)' }}
              width={8}
              height={33}
              viewBox="0 0 8 33"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.64645 32.3536C3.84171 32.5488 4.15829 32.5488 4.35355 32.3536L7.53554 29.1716C7.7308 28.9763 7.7308 28.6597 7.53554 28.4645C7.34027 28.2692 7.02369 28.2692 6.82843 28.4645L4 31.2929L1.17157 28.4645C0.976312 28.2692 0.65973 28.2692 0.464467 28.4645C0.269205 28.6597 0.269205 28.9763 0.464467 29.1716L3.64645 32.3536ZM3.5 2.18557e-08L3.5 32L4.5 32L4.5 -2.18557e-08L3.5 2.18557e-08Z"
                fill="currentColor"
              />
            </svg>
          </a>
        </div>
      <SectionHeadingStyle3
        title="Blogs"
        // subTitle="Recent Blog"
        variant="text-center"
        shape="shape_5"
      />
      <Spacing lg="75" md="60" />
      <section>
        <div className="container">
          {blogData.slice(0, itemShow).map((item, index) => (
            <PostStyle5
              key={index}
              thumbnailSrc={item.thumbnailSrc}
              title={item.title}
              title2={item.title2}
              subTitle={item.subTitle}
              href={item.href}
            />
          ))}
          {blogData.length <= itemShow ? (
            ""
          ) : (
            <div className="text-center">
              <Spacing lg="95" md="50" />
              <span
                className="cs_btn cs_style_1"
                onClick={() => setItemShow(itemShow + 3)}
              >
                Load More Blog
                <span>
                  <i>
                    <Icon icon="fa6-solid:arrow-right" />
                  </i>
                  <i>
                    <Icon icon="fa6-solid:arrow-right" />
                  </i>
                </span>
              </span>
            </div>
          )}
        </div>
      </section>
      <Spacing lg="150" md="80" />
    </>
  );
}
